'use client';

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const services = [
  { name: 'Main Website', status: 'operational' as const, responseTime: 142, uptime: 99.98 },
  { name: 'Flight Search API', status: 'operational' as const, responseTime: 287, uptime: 99.91 },
  { name: 'Booking Engine', status: 'operational' as const, responseTime: 198, uptime: 99.95 },
  { name: 'AI Recommendations', status: 'operational' as const, responseTime: 1240, uptime: 99.72 },
  { name: 'Email Service', status: 'degraded' as const, responseTime: 1850, uptime: 97.42 },
  { name: 'Database (Supabase)', status: 'maintenance' as const, responseTime: 0, uptime: 98.50 },
];

const statusConfig = {
  operational: { label: 'Operational', dot: 'bg-green-500', badge: 'bg-green-100 text-green-700' },
  degraded: { label: 'Degraded', dot: 'bg-yellow-500 animate-pulse', badge: 'bg-yellow-100 text-yellow-700' },
  down: { label: 'Down', dot: 'bg-red-500 animate-pulse', badge: 'bg-red-100 text-red-700' },
  maintenance: { label: 'Maintenance', dot: 'bg-sky-400', badge: 'bg-sky-100 text-sky-700' },
};

const SystemHealthMonitor = () => {
  const operational = services.filter(s => s.status === 'operational').length;
  const issues = services.filter(s => s.status !== 'operational').length;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground">System Health</h2>
          <p className="text-sm text-muted-foreground mt-1">{operational} operational · {issues} need attention</p>
        </div>
        <Link
          href="/system-health"
          className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-lg text-sm font-bold hover:bg-primary/90 transition-colors"
        >
          <Icon name="ArrowTopRightOnSquareIcon" size={16} />
          Full Dashboard
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {services.map((service, i) => {
          const cfg = statusConfig[service.status];
          return (
            <div key={i} className="bg-white rounded-xl border border-border p-4 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <span className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${cfg.dot}`} />
                <div>
                  <div className="font-bold text-sm text-foreground">{service.name}</div>
                  <div className="text-xs text-muted-foreground">Uptime: {service.uptime}%</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-xs font-bold text-muted-foreground">
                  {service.status === 'maintenance' ? '—' : `${service.responseTime}ms`}
                </span>
                <span className={`text-xs font-bold px-2 py-1 rounded-full ${cfg.badge}`}>{cfg.label}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SystemHealthMonitor;
